import React, { useState } from "react";
import { useLocation } from "react-router-dom";

const PersonalInformation = ({
  refName,
  refLastName,
  refDocumentType,
  refCivilStatus,
  refNationality,
  refDni,
  refCuil,
  refDateOfBirth,
  refPlaceOfBirth,
  refPhone,
  refEmail,
  refStreet,
  refNumberStreet,
  refPostalCode,
  refApartment,
  refFloor,
  refSocioEconomicLevel,
  refLocation,
  refProvince,
}) => {
  const data = useLocation();
  const [personalInformation, setPersonalInformation] = useState({
    name: data.state.data.name || "",
    lastName: data.state.data.lastName || "",
    documentType: data.state.data.documentType || "",
    civilStatus: data.state.data.civilStatus || "",
    nacionality: data.state.data.nacionality || "",
    dni: data.state.data.dni || "",
    cuil: data.state.data.cuil || "",
    birthdate: data.state.data.dateOfBirth || "",
    placeOfBirth: data.state.data.placeOfBirth || "",
    phone: data.state.data.phone || "",
    email: data.state.data.email || "",
    street: data.state.data.street || "",
    numberStreet: data.state.data.numberStreet || "",
    postalCode: data.state.data.postalCode || "",
    apartment: data.state.data.apartment || "",
    floor: data.state.data.floor || "",
    SocioEconomicLevel: data.state.data.SocioEconomicLevel || "",
    location: data.state.data.location || "",
    province: data.state.data.province || "",
  });

  return (
    <div className="section">
      <div className="tittleupdatebox">
        <p className="tittleupdate">Informacion Personal</p>
      </div>
      <div className="displayinputupdatebox">
        <div className="inputboxupdate">
          <label className="tittleinputupdate_Lealtad">Nombre:</label>
          <input
            ref={refName}
            className="inputupdate"
            type="text"
            defaultValue={personalInformation.name}
            onChange={(e) =>
              setPersonalInformation({
                ...personalInformation,
                name: e.target.value,
              })
            }
          />
        </div>
        <div className="inputboxupdate">
          <label className="tittleinputupdate_Lealtad">Apellido:</label>
          <input
            ref={refLastName}
            className="inputupdate"
            type="text"
            defaultValue={personalInformation.lastName}
            onChange={(e) =>
              setPersonalInformation({
                ...personalInformation,
                lastName: e.target.value,
              })
            }
          />
        </div>
        <div className="inputboxupdate">
          <label className="tittleinputupdate_Lealtad">
            Tipo de documento:
          </label>
          <select
            ref={refDocumentType}
            className="inputupdate"
            defaultValue={personalInformation.documentType}
            onChange={(e) =>
              setPersonalInformation({
                ...personalInformation,
                documentType: e.target.value,
              })
            }
          >
            <option value="">Selecciona una opción</option>
            <option value="DNI">DNI</option>
            <option value="CUIL">CUIL</option>
          </select>
        </div>
      </div>
      <div className="displayinputupdatebox">
        <div className="inputboxupdate">
          <label className="tittleinputupdate_Lealtad">
            Numero de documento:
          </label>
          <input
            ref={refDni}
            className="inputupdate"
            maxLength={8}
            type="text"
            defaultValue={personalInformation.dni}
            onChange={(e) =>
              setPersonalInformation({
                ...personalInformation,
                dni: e.target.value,
              })
            }
          />
        </div>
        <div className="inputboxupdate">
          <label className="tittleinputupdate_Lealtad">Estado civil:</label>
          <select
            ref={refCivilStatus}
            className="inputupdate"
            defaultValue={personalInformation.civilStatus}
            onChange={(e) =>
              setPersonalInformation({
                ...personalInformation,
                civilStatus: e.target.value,
              })
            }
          >
            <option value="Soltero/a">Soltero/a</option>
            <option value="Casado/a">Casado/a</option>
            <option value="Divorciado/a">Divorciado/a</option>
            <option value="Viudo/a">Viudo/a</option>
            <option value="Separado/a legalmente">Separado/a legalmente</option>
            <option value="Union libre o concubinato">
              Union libre o concubinato
            </option>
            <option value="Casado/a civilmente">Casado/a civilmente</option>
            <option value="Pareja de hecho">Pareja de hecho</option>
          </select>
        </div>
        <div className="inputboxupdate">
          <label className="tittleinputupdate_Lealtad">Nacionalidad:</label>
          <input
            ref={refNationality}
            className="inputupdate"
            type="text"
            defaultValue={personalInformation.nacionality}
            onChange={(e) =>
              setPersonalInformation({
                ...personalInformation,
                nacionality: e.target.value,
              })
            }
          />
        </div>
      </div>
      <div className="displayinputupdatebox">
        <div className="inputboxupdate">
          <label className="tittleinputupdate_Lealtad">Cuil:</label>
          <input
            ref={refCuil}
            className="inputupdate"
            maxLength="11"
            type="text"
            defaultValue={personalInformation.cuil}
            onChange={(e) =>
              setPersonalInformation({
                ...personalInformation,
                cuil: e.target.value,
              })
            }
          />
        </div>
        <div className="inputboxupdate">
          <label className="tittleinputupdate_Lealtad">
            Fecha de nacimiento:
          </label>
          <input
            ref={refDateOfBirth}
            className="inputupdate"
            type="date"
            defaultValue={personalInformation.birthdate}
            onChange={(e) =>
              setPersonalInformation({
                ...personalInformation,
                birthdate: e.target.value,
              })
            }
          />
        </div>
        <div className="inputboxupdate">
          <label className="tittleinputupdate_Lealtad">
            Lugar de nacimiento:
          </label>
          <input
            ref={refPlaceOfBirth}
            className="inputupdate"
            type="text"
            defaultValue={personalInformation.placeOfBirth}
            onChange={(e) =>
              setPersonalInformation({
                ...personalInformation,
                placeOfBirth: e.target.value,
              })
            }
          />
        </div>
      </div>
      <div className="displayinputupdatebox">
        <div className="inputboxupdate">
          <label className="tittleinputupdate_Lealtad">Teléfono:</label>
          <input
            ref={refPhone}
            className="inputupdate"
            type="text"
            defaultValue={personalInformation.phone}
            onChange={(e) =>
              setPersonalInformation({
                ...personalInformation,
                phone: e.target.value,
              })
            }
          />
        </div>
        <div className="inputboxupdate">
          <label className="tittleinputupdate_Lealtad">
            Correo electrónico:
          </label>
          <input
            ref={refEmail}
            className="inputupdate"
            type="text"
            defaultValue={personalInformation.email}
            onChange={(e) =>
              setPersonalInformation({
                ...personalInformation,
                email: e.target.value,
              })
            }
          />
        </div>
      </div>
      <div className="displayinputupdatebox">
        <div className="inputboxupdate">
          <label className="tittleinputupdate_Lealtad">Calle:</label>
          <input
            ref={refStreet}
            className="inputupdate"
            type="text"
            defaultValue={personalInformation.street}
            onChange={(e) =>
              setPersonalInformation({
                ...personalInformation,
                street: e.target.value,
              })
            }
          />
        </div>
        <div className="inputboxupdate">
          <label className="tittleinputupdate_Lealtad">Numero:</label>
          <input
            ref={refNumberStreet}
            className="inputupdate"
            type="text"
            defaultValue={personalInformation.numberStreet}
            onChange={(e) =>
              setPersonalInformation({
                ...personalInformation,
                numberStreet: e.target.value,
              })
            }
          />
        </div>
        <div className="inputboxupdate">
          <label className="tittleinputupdate_Lealtad">Codigo postal:</label>
          <input
            ref={refPostalCode}
            className="inputupdate"
            type="text"
            defaultValue={personalInformation.postalCode}
            onChange={(e) =>
              setPersonalInformation({
                ...personalInformation,
                postalCode: e.target.value,
              })
            }
          />
        </div>
      </div>
      <div className="displayinputupdatebox">
        <div className="inputboxupdate">
          <label className="tittleinputupdate_Lealtad">Departamento:</label>
          <input
            ref={refApartment}
            className="inputupdate"
            type="text"
            defaultValue={personalInformation.apartment}
            onChange={(e) =>
              setPersonalInformation({
                ...personalInformation,
                apartment: e.target.value,
              })
            }
          />
        </div>
        <div className="inputboxupdate">
          <label className="tittleinputupdate_Lealtad">Piso:</label>
          <input
            ref={refFloor}
            className="inputupdate"
            type="text"
            defaultValue={personalInformation.floor}
            onChange={(e) =>
              setPersonalInformation({
                ...personalInformation,
                floor: e.target.value,
              })
            }
          />
        </div>
        <div className="inputboxupdate">
          <label className="tittleinputupdate_Lealtad">
            Nivel socioeconómico:
          </label>
          <select
            ref={refSocioEconomicLevel}
            className="inputupdate"
            type="text"
            defaultValue={personalInformation.SocioEconomicLevel}
            onChange={(e) =>
              setPersonalInformation({
                ...personalInformation,
                SocioEconomicLevel: e.target.value,
              })
            }
          >
            <option value="">Selecciona una opción</option>
            <option value="D2">D2</option>
            <option value="D1">D1</option>
            <option value="C3">C3</option>
            <option value="C2">C2</option>
            <option value="C1">C1</option>
            <option value="B">B</option>
            <option value="A">A</option>
          </select>
        </div>
      </div>
      <div className="displayinputupdatebox">
        <div className="inputboxupdate">
          <label className="tittleinputupdate_Lealtad">Localidad:</label>
          <input
            ref={refLocation}
            className="inputupdate"
            type="text"
            defaultValue={personalInformation.location}
            onChange={(e) =>
              setPersonalInformation({
                ...personalInformation,
                location: e.target.value,
              })
            }
          />
        </div>
        <div className="inputboxupdate">
          <label className="tittleinputupdate_Lealtad">Provincia:</label>
          <select
            ref={refProvince}
            className="inputupdate"
            defaultValue={personalInformation.province}
            onChange={(e) =>
              setPersonalInformation({
                ...personalInformation,
                province: e.target.value,
              })
            }
          >
            <option value="">Selecciona una opción</option>
            <option value="Provincia de Buenos Aires">
              Provincia de Buenos Aires
            </option>
            <option value="Distinto a Provincia de Buenos Aires">
              Distinto a Provincia de Buenos Aires
            </option>
          </select>
        </div>
      </div>
    </div>
  );
};

export default PersonalInformation;
